import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ITipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/ITipoVisitaModel';
import { TipoVisitaModel } from 'src/app/models/tipo-visita/TipoVisitaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

@Component({
  templateUrl: './configuracion-tipo-visita-default-dialog.component.html',
  styleUrls: ['./configuracion-tipo-visita-default-dialog.component.css']
})
export class ConfiguracionTipoVisitaDefaultDialogComponent implements OnInit {

  idDefault: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ConfiguracionTipoVisitaDefaultDialogComponent>,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private tipoVisitaService: TipoVisitaService,
    @Inject(MAT_DIALOG_DATA) public model: SearchResultModel<ITipoVisitaModel[]>
  ) { }

  ngOnInit(): void {
    const itemDefault = this.model.items.find(
      (p) => p.defaulContratista
    );
    if(itemDefault)
      this.idDefault = itemDefault.idTipoVisita
  }
  onNoClick(): void {
    this.dialogRef.close();
  }  
  Save(): void{
    this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        let tipoVisita = new TipoVisitaModel();
        tipoVisita.idTipoVisita=this.idDefault
        this.tipoVisitaService.defaultcontratista(tipoVisita).subscribe((result : ActionResultModel) => {
          if(result.type==eTypeResult.SUCCESS){
            this.alertDialogService.open('El tipo de visita fue establecido por defecto para los contratistas'); //options          
            this.dialogRef.close();
          }
        });
      }
    });
  }

}
